import { NgModule } from '@angular/core';

import { ProfileCardComponent } from './profile-card.component';
import { ProfileAvatarModule } from 'components/profile-avatar/profile-avatar.module';
import { NgbTooltipModule } from '@ng-bootstrap/ng-bootstrap';
import {
  IconModule,
  SmartModalModule,
  SpinnerModule,
  TextInputModule,
  SelectModule,
  MultiSelectModule,
  RadioGroupModule,
  NumberInputModule,
} from '@certemy/ui-components';
import { UploadImageModalModule } from 'components/upload-image-modal';
import { CertemyCommonModule } from 'common/certemy-common.module';
import { UploadImageModalService } from 'components/upload-image-modal/upload-image-modal.service';
import { InternalIdModalComponent } from 'components/profile-card/modals/internal-id/internal-id.modal.component';
import { RegistryDetailsService } from 'features/registry-details/registry-details.service';
import { EditProfileModalComponent } from 'components/profile-card/modals/edit-profile/edit-profile.modal.component';
import { LocationsModule } from 'services/locations/locations.module';
import { ProfileCardAvatarComponent } from 'components/profile-card/profile-card-avatar/profile-card-avatar.component';
import { ProfileCardService } from 'components/profile-card/profile-card.service';
import { InlineErrorModule } from 'components/errors/inline-error.module';
import { EditProfileModalService } from 'components/profile-card/modals/edit-profile/edit-profile.modal.service';
import { ProfileLocationInfoComponent } from 'components/profile-card/profile-location-info/profile-location-info.component';
import { ProfileService } from 'services/profile/profile.service';
import { OrganizationRolesServiceModule } from 'features/organization-settings/organization-roles/organization-roles.module';
import { EditProfileManagerComponent } from './modals/edit-profile-manager/edit-profile-manager.component';

@NgModule({
  imports: [
    CertemyCommonModule,
    ProfileAvatarModule,
    NgbTooltipModule,
    IconModule,
    SpinnerModule,
    UploadImageModalModule,
    TextInputModule,
    SelectModule,
    LocationsModule,
    SmartModalModule.forRoot(),
    InlineErrorModule,
    MultiSelectModule,
    RadioGroupModule,
    OrganizationRolesServiceModule,
    NumberInputModule,
  ],
  exports: [ProfileCardComponent],
  declarations: [
    ProfileCardComponent,
    InternalIdModalComponent,
    EditProfileModalComponent,
    ProfileCardAvatarComponent,
    ProfileLocationInfoComponent,
    EditProfileManagerComponent,
  ],
  providers: [
    UploadImageModalService,
    RegistryDetailsService,
    ProfileCardService,
    EditProfileModalService,
    ProfileService,
  ],
})
export class ProfileCardModule {}
